<!--  -->
<template>
  <div>

      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="100px" class="searchForm">
          <el-row>
            <el-col :span="8">
                <el-form-item label="年份" >
                   <el-date-picker v-model="queryCondition.year" value-format="yyyy" format="yyyy" type="year" placeholder="选择年" style="width:100%"></el-date-picker>
                </el-form-item>
            </el-col>
            <el-col :span="8">
                <el-form-item label="Sponser" >
                    <el-input v-model="queryCondition.sponsorName" clearable style="width:100%"></el-input>
                </el-form-item>
            </el-col>
            <!-- <el-col :span="8">
                <el-form-item label="状态" >
                    <el-select v-model="queryCondition.status" clearable multiple filterable placeholder="请选择(支持多选)" style="width:100%">
                        <el-option :key="index" v-for="(item,index) in statusOptions" :label="item.name" :value="item.code"></el-option>
                    </el-select>
                </el-form-item>
            </el-col> -->
          </el-row>
          <el-row type="flex" justify="center" align="middle" style="margin-top:8px;">
            <el-button  size="mini" @click="queryData" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
            <el-button size="mini" @click="exportLog" type="primary">导出</el-button>
          </el-row>
        </el-form>
      </div>

      <el-table :data="tableData" style="width: 100%">
        <!-- <el-table-column prop="date" label="" width="90">
            <template slot-scope="scope">
                <el-radio :label="scope.row.invoiceHeaderId" v-model="templateRadio" @change.native="getTemplateRow(scope.$index,scope.row)">&nbsp;</el-radio>
            </template>
        </el-table-column> -->
        <el-table-column prop="yearQuarter" label="日期" > </el-table-column>
        <el-table-column prop="sponsorName" label="供应商" > </el-table-column>
        <el-table-column prop="action" label="操作" > </el-table-column>
        <el-table-column prop="userName" label="更新人" > </el-table-column>
        <el-table-column prop="createDate" label="更新日期" > </el-table-column>
     </el-table>
    <!-- <el-row type="flex" justify="center" align="middle" style="margin-top:8px;">
        <el-button  size="mini" @click="noUpdate" type="primary">确认无更新</el-button>
        <el-button size="mini" @click="close" type="primary">关闭</el-button>
    </el-row> -->
    <div class="pagination">
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
        </el-pagination>
    </div>
     



  </div>
</template>

<script>

import proteinDrug from "@/api/rmcProtein/drug";
import { fileService } from "@/api/common/file-utils";
import commonFunction from "@/utils/dataTableUtils";

export default {
  data () {
    return {
        getRadioVal:"",
        tableData:[],
        totalCount:"",
        queryCondition:{
            year:"",
            sponsorName:"",
            pageNum: 1,
            pageSize: 15,
        },
        statusOptions:[],
    };
  },
  created(){
    this.getDataInfo()
  },
  components: {},

  computed: {},

  methods: {
     getDataInfo(){
         proteinDrug.queryPageForUpdateLog(this.queryCondition).then((res)=>{
             this.tableData=res.resultData
             this.totalCount=res.totalCount
         })
     },
     exportLog(){
         proteinDrug.downloadUpdateLogList(this.queryCondition).then((res)=>{
              fileService.respToFile(res, 'Protein_药品清单_更新日志报表');
          //  fileService.resNameToFile(res,'Protein_药品清单_更新日志报表');
         })
     },
      // 单选获取的数据
     getTemplateRow(index,row){
       this.getRadioVal=row.invoiceHeaderId
     },
     queryData(){
          this.getDataInfo()
     },
     onReset(){
          this.queryCondition={
            year:"",
            sponsorName:"",
            pageNum: 1,
            pageSize: 15,
          }
        this.getDataInfo()
     },
     noUpdate(){
          console.log("确认无更新")
          this.close()
     },
     close(){
          this.$emit("close")
     },
     pageSizeChange(val){
        this.queryCondition.pageSize = val
        this.queryData()
     },
     pageNumberChange(val){
        this.queryCondition.pageNum = val
        this.queryData()
     },
  },
  extends: commonFunction

}

</script>
<style>
.el-dialog__header{
    border-bottom: 1px solid #ccc !important;
    padding: 10px 20px 10px;
    box-sizing: border-box;
}
</style>
<style  scoped>

</style>